export function footerNavigation() {
    const footerNav = this._document.querySelector(".footer-nav");
    const navBlocks = footerNav.querySelectorAll(".has-children");
    
    [...navBlocks].forEach((item) => {
        item.querySelector(".expand-btn").addEventListener("click", (event) => {
            if(!item.classList.contains("expanded")) {
                [...navBlocks].forEach((item) => {
                    item.classList.remove("expanded");
                });
            }
            event.target.parentNode.classList.toggle("expanded");
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer-navigation.js